import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPrint,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

import { DEFAULT_PRINT_OPTIONS } from "../utils/printOptions";

const getViewPrintLabel = (currentView) => {
  if (currentView === "teacher") return "teacher";
  if (currentView === "course") return "course";
  if (currentView === "classroom") return "classroom";
  if (currentView === "student") return "student";
  return "row";
};

export default function MagnetboardPrintOptionsModal({
  currentView,
  rowCount,
  searchValue,
  onClose,
  onPrint,
}) {
  const [draftPrintOptions, setDraftPrintOptions] = useState(DEFAULT_PRINT_OPTIONS);

  useEffect(() => {
    setDraftPrintOptions(DEFAULT_PRINT_OPTIONS);
  }, []);

  const updateDraftPrintOption = (optionKey, value) => {
    setDraftPrintOptions((current_options) => ({
      ...current_options,
      [optionKey]: value,
    }));
  };

  const handlePrint = () => {
    onPrint({
      printOptions: draftPrintOptions,
    });
  };

  const searchIsActive = Boolean(searchValue && searchValue.trim());
  const viewPrintLabel = getViewPrintLabel(currentView);

  return (
    <div className="mb-print-options-modal-screen">
      <div className="mb-print-options-modal-content">
        <div className="mb-print-options-modal-header">
          <div>
            <h2>Print Schedule</h2>
            <div className="mb-print-options-modal-subtitle">
              {rowCount} current {rowCount === 1 ? viewPrintLabel : `${viewPrintLabel}s`} selected
            </div>
          </div>
          <button type="button" className="mb-print-options-icon-btn" onClick={onClose} aria-label="Close print options">
            <FontAwesomeIcon icon={faTimes}/>
          </button>
        </div>

        {searchIsActive && (
          <div className="mb-print-options-search-chip">
            Search applied: <strong>{searchValue}</strong>
          </div>
        )}

        <div className="mb-print-options-layout mb-print-options-layout-no-filters">
          <div className="mb-print-options-panel">
            <div className="mb-print-options-panel-title">Display</div>
            <div className="mb-print-options-toggle-list">
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftPrintOptions.showClassroom}
                  onChange={(event) => updateDraftPrintOption("showClassroom", event.target.checked)}
                />
                <span>Show classroom</span>
              </label>
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftPrintOptions.showStudentCount}
                  onChange={(event) => updateDraftPrintOption("showStudentCount", event.target.checked)}
                />
                <span>Show student count</span>
              </label>
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftPrintOptions.showConflictsWarnings}
                  onChange={(event) => updateDraftPrintOption("showConflictsWarnings", event.target.checked)}
                />
                <span>Show conflicts/warnings</span>
              </label>
              <label className="mb-print-options-toggle-row">
                <input
                  type="checkbox"
                  checked={draftPrintOptions.printOnePerPage}
                  onChange={(event) => updateDraftPrintOption("printOnePerPage", event.target.checked)}
                />
                <span>Print one {viewPrintLabel} per page</span>
              </label>
            </div>

            <div className="mb-print-options-panel-title mb-print-options-panel-title-spaced">Orientation</div>
            <div className="mb-print-options-segmented">
              <button
                type="button"
                className={draftPrintOptions.orientation === "landscape" ? "selected" : ""}
                onClick={() => updateDraftPrintOption("orientation", "landscape")}
              >
                Landscape
              </button>
              <button
                type="button"
                className={draftPrintOptions.orientation === "portrait" ? "selected" : ""}
                onClick={() => updateDraftPrintOption("orientation", "portrait")}
              >
                Portrait
              </button>
            </div>
          </div>
        </div>

        <div className="mb-print-options-modal-footer">
          <button type="button" className="mb-print-options-secondary-btn" onClick={onClose}>Cancel</button>
          <button type="button" className="mb-print-options-primary-btn" onClick={handlePrint}>
            <FontAwesomeIcon icon={faPrint}/>
            Print
          </button>
        </div>
      </div>
    </div>
  );
}
